import React from 'react';
import Icon from '../../../components/AppIcon';

const MemberFilter = ({ persons, selectedPersons, onFilterChange }) => {
  const handleTogglePerson = (personId) => {
    if (selectedPersons?.includes(personId)) {
      onFilterChange(selectedPersons?.filter(id => id !== personId));
    } else {
      onFilterChange([...selectedPersons, personId]);
    }
  };

  const handleSelectAll = () => {
    if (selectedPersons?.length === persons?.length) {
      onFilterChange([]);
    } else {
      onFilterChange(persons?.map(p => p?.id));
    }
  };

  const isAllSelected = selectedPersons?.length === persons?.length;

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-5 lg:p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 md:gap-3">
          <Icon name="filter" size={20} className="text-primary" />
          <h2 className="text-base md:text-lg lg:text-xl font-semibold text-foreground">
            Filter by Member
          </h2>
        </div>
        <button
          onClick={handleSelectAll}
          className="text-xs md:text-sm font-medium text-primary hover:text-primary/80 transition-smooth"
        >
          {isAllSelected ? 'Clear All' : 'Select All'}
        </button>
      </div>
      <div className="flex flex-wrap gap-2 md:gap-3">
        {persons?.map((person) => {
          const isSelected = selectedPersons?.includes(person?.id);
          
          return (
            <button
              key={person?.id}
              onClick={() => handleTogglePerson(person?.id)}
              className={`flex items-center gap-2 px-3 md:px-4 py-2 md:py-2.5 rounded-lg border-2 transition-smooth ${
                isSelected 
                  ? 'border-current shadow-warm-sm' 
                  : 'border-border hover:border-muted-foreground'
              }`}
              style={{
                color: isSelected ? person?.color : 'inherit',
                backgroundColor: isSelected ? `${person?.color}10` : 'transparent'
              }}
              aria-pressed={isSelected}
              aria-label={`${isSelected ? 'Deselect' : 'Select'} ${person?.name}`}
            >
              <div 
                className="w-6 h-6 md:w-8 md:h-8 rounded-lg flex items-center justify-center text-white text-xs md:text-sm font-semibold flex-shrink-0"
                style={{ backgroundColor: person?.color }}
              >
                {person?.initials}
              </div>
              <div className="text-left min-w-0">
                <div className="text-xs md:text-sm font-medium text-foreground truncate">
                  {person?.name}
                </div>
                <div className="text-xs text-muted-foreground truncate">
                  {person?.role}
                </div>
              </div>
              {isSelected && (
                <Icon name="check" size={16} className="flex-shrink-0" />
              )}
            </button>
          );
        })}
      </div>
      {selectedPersons?.length > 0 && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center justify-between text-xs md:text-sm">
            <span className="text-muted-foreground">
              Showing tasks for {selectedPersons?.length} {selectedPersons?.length === 1 ? 'member' : 'members'}
            </span>
            <div className="flex items-center gap-1">
              {selectedPersons?.map(personId => {
                const person = persons?.find(p => p?.id === personId);
                return person ? (
                  <div
                    key={person?.id}
                    className="w-6 h-6 rounded-full border-2 border-background"
                    style={{ backgroundColor: person?.color }}
                    title={person?.name}
                  />
                ) : null;
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MemberFilter;